import { Component, EventEmitter, h, Listen, Prop, Event } from '@stencil/core';
import { FacetUpdateEvent, PaginationData, FacetChangeEvent, FacetItem, logDebug } from '@hpfc/fc-frontend-core';

/**
 * @description The fccd-facet-select creates a select wrapped with a panel.
 * @use
 */
@Component({
  tag: 'fccd-pagination',
})
export class Pagination {
  /**
   * The id for the element in this component.
   */
  @Prop() elementId!: string;
  /**
   * the total item count.
   */
  @Prop({ mutable: true }) pageCount: number;
  /**
   * The current selected page.
   */
  @Prop({ mutable: true }) pageCurrent: number;

  /**
   * Dispatches this event when a selection is made.
   */
  @Event() fccdFacetChangeEvent: EventEmitter<FacetChangeEvent>;

  @Listen('hp5PaginationControlEvent', { target: 'document' })
  selectHandler(event: CustomEvent) {
    if (event?.detail?.page) {
      const paginationData: PaginationData = new PaginationData(event.detail.page, this.pageCount);
      paginationData.changingPage = true;
      const facetItem = new FacetItem(this.elementId, paginationData);
      this.fccdFacetChangeEvent.emit(new FacetChangeEvent(event, facetItem));
    }
  }

  @Listen('fccdComponentEvent', { target: 'document' })
  updateHandler(event: CustomEvent<FacetUpdateEvent>) {
    if (event?.detail?.facetMap) {
      if (event.detail.facetMap.has(this.elementId) && event.detail.facetMap.get(this.elementId).value instanceof PaginationData) {
        const pageData: PaginationData = event.detail.facetMap.get(this.elementId).value as PaginationData;
        this.pageCurrent = pageData.page;
        this.pageCount = pageData.pageCount;
        logDebug('caught fccdComponentEvent for element: ' + this.elementId);
      }
    }
  }

  private getPanelName(): string {
    return 'pagination-' + this.elementId;
  }

  // Notes on the hp5-select it does not allow empty label text so we are feeding it an empty string.
  render() {
    return (
      <div>
        <hp5-pagination-control element-id={this.getPanelName()} label-size-selection="xs" page-count={this.pageCount} page-current={this.pageCurrent}></hp5-pagination-control>
      </div>
    );
  }
}
